import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./Tag.module.css";

const Tag: React.FC<TagProps> = ({
  className,
  icon,
  children,
  type = "main",
}) => (
  <span className={classNames(styles.tag, className, styles[`tag--${type}`])}>
    {icon}
    {children}
  </span>
);

export type TagProps = {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  type?:
    | "main"
    | "contrast"
    | "complementary"
    | "complementaryContrast"
    | "info"
    | "success"
    | "error"
    | "disabled";
};

export default Tag;
